<!--  -->
<template>
    <div class='breadcrumbWrapper' :class="noBg ? '' : 'bg'" v-if="isShow">
        <div class="Inner pcmiddle mobileWrap flexRow">
            <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path:item.path,query: { Id:item.Id ,Title:item.Name} }"  v-for="(item,index) in crumbsarr" :key="index">{{item.Name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>

export default {
    props:{
        crumbsarr:{
            type:Array,
            default:[]
        },
        noBg: {
            type: Boolean,
            default: false
        }
    },
    data() {
     return {
         isShow:this.crumbsarr.length?true:false
     };
    },
    mounted() {
    },
    methods: {
    
    },
    components:{
    
    },
    created() {
    
    },
    computed: {},
    watch: {},
}
</script>
<style lang='scss'>
    .bg{
        background: #F5F8FA;
    }
    .breadcrumbWrapper{
        width: 100%;
        height: 50px;
        .Inner{
            height: 50px;
            align-items: center;
        }
    }
    @media screen and (max-width: 1024px) {
        .breadcrumbWrapper{
            height: 100px;
           .mobileWrap{
                height: 100px;
                align-items: center;
                width:calc(100% - 60px);
                padding:0 30px;
                .el-breadcrumb__item{
                    font-size: 32px;
                }
            } 
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/crumbs.vue